import {
  LOGIN_USER_OTT,
  LOGIN_USER_OTT_SUCESS,
  LOGIN_USER_OTT__FAIL,

  LOGOUT_USER,

  CHECK_EMAIL_FETCH,
  CHECK_EMAIL_FETCH_SUCCESS,
  CHECK_EMAIL_FETCH_FAIL,

  CHECK_TEL_FETCH,
  CHECK_TEL_FETCH_SUCCESS,
  CHECK_TEL_FETCH_FAIL
} from '../actions';

const INIT_STATE = {
  user: [],
  loading: false,
  error: '',
  userId: localStorage.getItem('user_id'),
  userInfo: localStorage.getItem('user_info'),
  checkMail: [],
  checkMailloading: false,
  checkMailError: '',
  checkTelloading: false,
  checkTelError: '',
  checkTel: []
};

export default (state = INIT_STATE, action) => {
  // console.log('action -> ', action)
  switch (action.type) {
    case LOGIN_USER_OTT:
      return { ...state, loading: true, error: '' };
    case LOGIN_USER_OTT_SUCESS:
      return { ...state, loading: false, user: action.payload, error: '' };
    case LOGIN_USER_OTT__FAIL:
      return { ...state, loading: false, user: '', error: action.payload.message };

    case LOGOUT_USER:
      return { ...state, user: null, error: '' };

    /* check mail */
    case CHECK_EMAIL_FETCH:
      return { ...state, checkMailloading: true, checkMailError: '' };
    case CHECK_EMAIL_FETCH_SUCCESS:
      return { ...state, checkMailloading: false, checkMail: action.payload.checkMail, checkMailError: '' };
    case CHECK_EMAIL_FETCH_FAIL:
      return { ...state, checkMailloading: false, checkMail: action.payload.statusCode, checkMailError: action.payload.message };

    /* check tel */
    case CHECK_TEL_FETCH:
      return { ...state, checkTelloading: true, checkTelError: '' };
    case CHECK_TEL_FETCH_SUCCESS:
      return { ...state, checkTelloading: false, checkTel: action.payload.checkTel, checkTelError: '' };
    case CHECK_TEL_FETCH_FAIL:
      return { ...state, checkTelloading: false, checkTel: action.payload.statusCode, checkTelError: action.payload.message };

    default: return { ...state };
  }
}
